import { AuditColumnModel, EntityModel } from "src/app/model";

export interface RelationalEntityListModel extends 
  Pick<EntityModel, "_id" | "name" | "uniqueId" | "category">  {
    alertsCount?: number;
}